import { Airport } from './airport'

/**
 * Class representing a flight
 */
export class Flight {
/**
 * Create a Flight.
 * @param {object} options - the flight's options to construct the flight object with
 * @param {String} bookingReference - the id of the booking reference
 * @param {String} flightReference - the id of flight reference
 * @param {Number} flightDate - the date of the flight in epoch format
 * @param {Array} flightData - details about taken flight if it a valid flight was found
 *                             using flight reference id
 * @param {Airport} arrivalAirport - arrival airport
 * @param {Airport} departureAirport - departure airport
 */
  constructor (options) {
    this.bookingReference = options.bookingReference
    this.flightReference = options.flightReference
    this.flightDate = options.flightDate
    this.flightData = options.flightData
    this.arrivalAirport = options.arrivalAirport
    this.departureAirport = options.departureAirport
  }

  get bookingReference () {
    return this._bookingReference
  }

  set bookingReference (value) {
    if (value) this._bookingReference = String(value)
    else this._bookingReference = null
  }

  get flightReference () {
    return this._flightReference
  }

  set flightReference (value) {
    if (value) this._flightReference = String(value)
    else this._flightReference = null
  }

  get flightDate () {
    return this._flightDate
  }

  set flightDate (value) {
    if (value) this._flightDate = Number(value)
    else this._flightDate = null
  }

  get flightData () {
    return this._flightData
  }

  set flightData (value) {
    this._flightData = value
  }

  get arrivalAirport () {
    return this._arrivalAirport
  }

  set arrivalAirport (value) {
    if (value && !(value instanceof Airport)) {
      throw new TypeError('arrival airport is not an instance of Airport')
    }
    this._arrivalAirport = value
  }

  get departureAirport () {
    return this._departureAirport
  }

  set departureAirport (value) {
    if (value && !(value instanceof Airport)) {
      throw new TypeError('departure airport is not an instance of Airport')
    }
    this._departureAirport = value
  }

  toJSON () {
    return {
      bookingReference: this._bookingReference,
      flightReference: this._flightReference,
      flightDate: this._flightDate,
      flightData: JSON.stringify(this._flightData),
      arrivalAirport: this._arrivalAirport,
      departureAirport: this._departureAirport
    }
  }
}
